/**
 * The file-header divider lives on the sticky header. It may borrow the first
 * row's selected colour only while that row is still flush underneath.
 */
export const isFirstRowFlushWithFileHeader = (
  headerBottom: number,
  firstRowTop: number,
): boolean => firstRowTop >= headerBottom - 1;
